export default __webpack_public_path__ + "static/media/circleGreen.4ebfd832.svg";